import Cookies from 'js-cookie'

const DEFAULT_OPTIONS = [10, 25, 50, 100]
const EXPIRES_DAYS = 365

export function getPerPage(key, fallback, allowed = DEFAULT_OPTIONS) {
    const value = Number(Cookies.get(key))
    return allowed.includes(value) ? value : fallback
}

export function setPerPage(key, value, allowed = DEFAULT_OPTIONS) {
    const n = Number(value)
    if (allowed.includes(n)) {
        Cookies.set(key, String(n), { expires: EXPIRES_DAYS })
    }
}
